import React, { useState, useEffect } from 'react'
import NotificationContentCard from './Card/NotificationContentCard'
import io from 'socket.io-client'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'
import { Config } from '../../utils/initialConfig'

const initialDataNotif = {
  type: 'payment-pending',
  title: 'Pembayaran Tertunda',
  dateTime: new Date().toLocaleString(),
  message: 'Pembayaran Anda sedang dalam proses.'
}

const PopupNotification = () => {
  const userData = useSelector((state) => state.auth)

  const [visible, setVisible] = useState(false)
  const [dataNotif, setDataNotif] = useState(initialDataNotif)
  const [isConnected, setIsConnected] = useState(false)

  const socket = io(Config.REACT_SOCKET_IO_URL, {
    transports: ['websocket'],
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
    autoConnect: true
  })

  useEffect(() => {
    function onConnect() {
      setIsConnected(true)
      socket.emit('JoinRoomNotification', `${userData?.access_token}`)
    }

    function onDisconnect() {
      setIsConnected(false)
    }

    socket.on('connect', onConnect)
    socket.on('disconnect', onDisconnect)

    socket.on('ReceiveNotification', (data) => {
      setDataNotif(JSON.parse(data))
      setVisible(true)

      setTimeout(() => {
        setVisible(false)
      }, 3000)
    })

    socket.on('connect_error', (error) => {
      setIsConnected(false)
    })
    return () => {
      socket.off('connect', onConnect)
      socket.off('disconnect', onDisconnect)
    }
  }, [])

  if (!visible) return null

  return (
    <div className="w-fit h-fit fixed top-1/4 right-4 transform -translate-y-1/2 shadow-lg rounded-lg z-50">
      <NotificationContentCard
        type={dataNotif.type}
        title={dataNotif.title}
        dateTime={dayjs(dataNotif?.created_at).format('HH:mm')}
        message={dataNotif.description}
        sourceId={dataNotif.source_id}
        duration={3000}
        id={dataNotif.id}
        source_table={dataNotif.source_table}
      />
    </div>
  )
}

export default PopupNotification
